<template>
  <div class="container py-6 md:py-12">
    <div class="my-4 md:my-8 md:flex md:items-center">
      <img
        class="w-full mt-6 md:w-1/2 md:mr-8 md:mt-0"
        src="@/assets/images/what.png"
        alt=""
      />
      <div class="mt-4 flex-grow md:text-5xl md:mt-0">
        <p class="">Oups 404!</p>
        <p><router-link class="btn btn--primary" to="/">Home</router-link></p>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped></style>
